import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-photo-carousel',
  templateUrl: './photo-carousel.component.html',
  styleUrls: ['./photo-carousel.component.css']
})
export class PhotoCarouselComponent implements OnInit {
  ngOnInit(): void {
  }

  images = [
    { url: 'https://voyjaleas-website.sebtec12.workers.dev/univDeAlcala.JPG', caption: 'Starting out in Costa Rica 🌴' },
    { url: 'https://voyjaleas-website.sebtec12.workers.dev/SEBAS_sierraDeMadrid.HEIC', caption: 'Landing in Spain 🇪🇸' },
    { url: 'https://voyjaleas-website.sebtec12.workers.dev/SEBAS_sierraDeMadrid.HEIC', caption: 'My first client meeting 🤝' },
    // Add more images as you like
  ];

  currentIndex = 0;

  nextSlide() {
    if (this.currentIndex < this.images.length - 1) {
      this.currentIndex++;
    }
  }

  prevSlide() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  openFullscreen(image) {
    // Optionally open in a modal
    console.log('Open fullscreen view for:', image);
  }
}
